import { SORT_PREFIX, OrderTypes } from '@/constants';
import {
  getFiltersFromSearchParams,
  getKeyWidthPrefix,
  getTransformedFilterToObjectAndType,
} from '@/utils';

export const setSearchParamsToState = (searchParams, setQueryParams, queryParamsInitial) => {
  const searchParamsObject = Object.fromEntries([...searchParams]);

  setQueryParams((prev) => ({
    ...prev,
    page: searchParamsObject.page ? Number(searchParamsObject.page) : queryParamsInitial.page,
    pageSize: searchParamsObject.pageSize
      ? Number(searchParamsObject.pageSize)
      : queryParamsInitial.pageSize,
    sortKey: searchParamsObject.sortKey || queryParamsInitial.sortKey,
    sortDirection:
      searchParamsObject.sortDirection === OrderTypes.Desc
        ? OrderTypes.Desc
        : searchParamsObject.sortDirection === OrderTypes.Asc
        ? OrderTypes.Asc
        : queryParamsInitial.sortDirection,
    filters: getFiltersFromSearchParams(searchParamsObject),
    tab: searchParamsObject.tab ? searchParamsObject.tab : queryParamsInitial.tab,
  }));
};

export const setTab = (value, setSearchParams) => {
  const newParams = new URLSearchParams();
  newParams.set('tab', value);
  setSearchParams(newParams, { replace: true });
};

export const getVariables = (queryParams, instructionTypeForFilter) => {
  let variables = {
    page: queryParams.page,
    pageSize: queryParams.pageSize,
    deletedAt: null,
  };

  if (queryParams.sortKey && queryParams.sortDirection) {
    variables[getKeyWidthPrefix(queryParams.sortKey, SORT_PREFIX)] = queryParams.sortDirection;
  }

  if (queryParams.filters) {
    variables = {
      ...variables,
      ...getTransformedFilterToObjectAndType(queryParams.filters, instructionTypeForFilter),
    };
  }

  return variables;
};
